// (c) chaehongee. Confidential and proprietary.

export interface NewsletterSignupRequest {
  email: string
  source?: string
  tags?: string[]
}

export interface NewsletterSignupResponse {
  success: boolean
  message: string
  subscriber_id?: string
}

export async function subscribeToNewsletter(
  request: NewsletterSignupRequest
): Promise<NewsletterSignupResponse> {
  const response = await fetch('/api/v1/newsletter/subscribe', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      ...request,
      source: request.source || 'landing_page',
    }),
  })

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({ detail: 'Unknown error' }))
    throw new Error(errorData.detail || `HTTP ${response.status}`)
  }

  return response.json()
}

// Export for admin use - get subscriber count (future feature)
export async function getSubscriberCount(): Promise<{ count: number }> {
  const response = await fetch('/api/v1/newsletter/count', {
    method: 'GET',
  })

  if (!response.ok) {
    throw new Error(`HTTP ${response.status}`)
  }

  return response.json()
}

